if (!customElements.get('product-action-buttons')) {
  customElements.define(
    'product-action-buttons',
    class ProductActionButtons extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const button = document.querySelector('#sign-up-button');
        button.addEventListener('click', () => {
          this.scrollDown();
          setTimeout(() => {
            this.highlightInput();
          }, 1000);
        });
      }
      
      scrollDown() {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        });
      }

      highlightInput() {
        let input = document.querySelector('.newsletters-form input');

        input.classList.add('pulse');
        setTimeout(() => {
          input.classList.remove('pulse');
        }, 3000);
      }
    }
  );
}
